// 设定APP传参的加密用户名
export const setUserName = ({ commit }, userName) => {
  // 方法调用的先后顺序不能变
  commit('setUserName', userName)
}
// 设定用户code
export const setUserCode = ({ commit }, userCode) => {
  // 方法调用的先后顺序不能变
  commit('setUserCode', userCode)
}
// 设定零件ID
export const setPartNo = ({ commit }, partNo) => {
  // 方法调用的先后顺序不能变
  commit('setPartNo', partNo)
}
// 设定CSHID
export const setCshPicker = ({ commit }, cshPicker) => {
  // 方法调用的先后顺序不能变
  commit('setCshPicker', cshPicker)
}
// 设定订单状态筛选
export const setOrderStatus = ({ commit }, orderStatusList) => {
  // 方法调用的先后顺序不能变
  commit('setOrderStatus', orderStatusList)
}
// 设定订单状态筛选Index
export const setOrderStatusIndex = ({ commit }, name) => {
  // 方法调用的先后顺序不能变
  commit('setOrderStatusIndex', name)
}
// 设定用户类型筛选
export const setUserType = ({ commit }, userType) => {
  // 方法调用的先后顺序不能变
  commit('setUserType', userType)
}
// 设定订单状态筛选Index
export const setUserTypeIndex = ({ commit }, userTypeIndex) => {
  // 方法调用的先后顺序不能变
  commit('setUserTypeIndex', userTypeIndex)
}
// 设定显示个人用户筛选Index
export const setShowPersonal = ({ commit }, showPersonalFlg) => {
  // 方法调用的先后顺序不能变
  commit('setShowPersonal', showPersonalFlg)
}
// 设定显示个人用户筛选Index
export const setSearchContent = ({ commit }, searchContent) => {
  // 方法调用的先后顺序不能变
  commit('setSearchContent', searchContent)
}
